<i18n
  src="@/locales/views/agro_exporter/quality_reports/process/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/quality_reports/process/base.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_reports_process_list_processes_path"
    :params="{ agro_exporter_id: agro_exporter_id }"
  />

  <bread-crumbs
    :labels="[module_name, agro_exporter_process.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-gray-200">
          <li
            v-for="(report, index) in quality_template_main_reps"
            :key="index"
          >
            <div
              class="block hover:bg-gray-50 cursor-pointer"
              @click="goToShowTemplateRep(report)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ report.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </a>
                  </div>
                </div>

                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p class="flex items-center text-sm text-gray-500">
                      <i
                        class="fa-solid fa-crate-apple flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ report.number_harvested_batches_with_inspects }} /
                      {{ report.number_harvested_batches }}
                    </p>
                    <p
                      class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                    >
                      <i
                        class="fa-solid fa-box-check flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ report.number_inspects }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/process/list_templates.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  components: { BreadCrumbs },
  name: "AEQualityReportsProcessListTemplates",
  props: ["agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      quality_template_main_reps: []
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchQualityTemplateMainRes: async function () {
      let response = await Requester.fetchQualityTemplateMainRes(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.quality_template_main_reps = response.data;
      this.load_data_general = true;
    },
    goToShowTemplateRep: function (quality_template_main_rep) {
      this.$router.push({
        name: "ae_quality_reports_process_show_template_rep_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          quality_template_main_rep_id: quality_template_main_rep.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchQualityTemplateMainRes();
      })
    );
  }
};
</script>
